export default "__VITE_ASSET__CfGvrPJo__"